import { InfoCircleOutlined } from '@ant-design/icons';
import { message } from 'antd';
import TcMap from 'components/UI/Map/TcMap';
import ShowLocationMap from 'components/UI/Map/showLocationModal/ShowLocationMap';
import TcCoverLoading from 'components/UI/TcLoading/TcCoverLoading';
import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendGetGeneric } from 'global/Models/globalModels';
import { inqueryKiosk, inqueryLocker, orderReservedByLocker, userAccessibleLKiosk } from 'global/Models/lockerModel';
import { lockerInfo, packageCreate } from 'global/Models/omOrderModel';
import OmParcelOrderModel from 'global/Models/omParcelOrderModel';
import { handleApiThen, handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import ApiService, { errorResponse } from 'global/utils/ApiService';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setOmOrderReservedByLocker } from 'redux/reducer/ParcelOrder/parcelOrderReducer';
import { RootState } from 'redux/store';

interface Props {
  loading?: boolean;
  cityId?: number;
  packages: packageCreate[] | undefined;
  index: number;
  userAccessibleKiosksList?: IBackendGetGeneric<userAccessibleLKiosk>;
  setLockerAddress?: (_locker: lockerInfo) => void;
}

const OrderSelectLockerListOnMapTab: FC<Props> = ({ userAccessibleKiosksList, cityId, packages, index, setLockerAddress }) => {
  //states
  const [showMap, setShowMap] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const omOrderReservedByLocker = useSelector((state: RootState) => state.parcelOrder.omOrderReservedByLocker);
  const [inqueryKioskloading, setInqueryKioskloading] = useState<boolean>(false);
  //hook
  const dispatch = useDispatch();

  //effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMap(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, [cityId]);

  console.log('packages', packages);

  //function
  const reserveLocker = async (locker: inqueryLocker): Promise<boolean> => {
    if (!cityId) return false;
    if (!packages) return false;
    let isSuccess = true;
    await ApiService.post(endpointUrls.lockerInsertOrder, {
      lockerId: locker.id,
      sourceCityId: packages[0].sourceCity?.id,
      destinationCityId: packages[0].destinationCity?.id,
    }).then((res: IBackendGetGeneric<{ order: orderReservedByLocker }>) => {
      handleApiThen({
        res,
        onSuccess: () => {
          isSuccess = true;
          dispatch(setOmOrderReservedByLocker(res.data.order));
          setLockerAddress &&
            setLockerAddress({
              orderNumber: res.data.order.orderNumber,
              // payType: res.data.order.paymentType,
              locker,
              cityId,
            });
        },
        notifFail: true,
        notifSuccess: true,
        onFailed: () => {},
      });
    });

    return isSuccess;
  };

  const callReservationForEachLocker = async (lockersList: inqueryLocker[]) => {
    setLoading(true);

    for (let i = 0; i < lockersList.length; i++) {
      const locker = lockersList[i];
      const isSuccess = await reserveLocker(locker);
      if (isSuccess) {
        setLoading(false);
        break;
      }

      if (i === lockersList.length - 1) {
        message.error('تمام قفسه های این کیوسک قبلا رزرو شده است. لطفا چند لحظه دیگر امتحان کنید.');
        setLoading(false);
      }
    }
  };

  const callInquiryKioskForGettingEmptyLockers = async (bunchId: number) => {
    if (!packages) return;
    setInqueryKioskloading(true);
    const pack = packages ? packages[index] : ({} as packageCreate);
    // How It Works:
    // The code iterates over each package in the pack array, creating objects with dimensions and weight. If count is 1, a single object is added; otherwise, multiple objects are added based on count.
    const payload = {
      dimensions: pack.package.flatMap((pkg) => {
        const { width, height, length, weight, count } = pkg;
        if (!count || count < 2) {
          return [{ width, height, length, weight }];
        } else {
          return Array.from({ length: count }, () => ({ width, height, length, weight }));
        }
      }),
    };
    await ApiService.post(endpointUrls.lockerInqueryBunch, {
      sourceCityId: packages[index].sourceCity?.id,
      destinationCityId: packages[index].destinationCity?.id,
      bunchId,
      ...payload,
    })
      .then((res: IBackendGetGeneric<inqueryKiosk>) =>
        handleApiThenGeneric<IBackendGetGeneric<inqueryKiosk>, inqueryKiosk>({
          res,
          onSuccessData: (data) => {
            callReservationForEachLocker(data.lockers);
          },
          notifFail: true,
          notifSuccess: false,
          // onFailed: () => message.error('خطا در دریافت لیست لاکرهای این کیوسک'),
        })
      )
      .catch(() => localApiCatcher(errorResponse));
    setInqueryKioskloading(false);
  };

  //constant
  const kioskList = userAccessibleKiosksList?.data.bunches;

  return (
    <>
      {showMap && !omOrderReservedByLocker && (
        <>
          <div className='flex items-center pb-1 font-medium'>
            <InfoCircleOutlined className='ml-1 text-base animate-pulse inherit-color text-t-error-color' />
            با انتخاب کیوسک مدنظر روی نقشه امکان رزرو کیوسک برای شما فعال می شود.
          </div>
          <TcMap zoomLevel={12} customHeight=' h-[65vh] '>
            {kioskList?.map(({ id, lat, lon, address }) => (
              <ShowLocationMap
                key={id}
                location={{ lat, lng: lon }}
                popupMarker={OmParcelOrderModel.PopupMarkerContent(loading, inqueryKioskloading, callInquiryKioskForGettingEmptyLockers, { address, lat, lng: lon, id })}
              />
            ))}
          </TcMap>
        </>
      )}
      {!showMap && <TcCoverLoading />}
    </>
  );
};

export default OrderSelectLockerListOnMapTab;
